import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { isAdFreeUser } from '../../utils/isAdFreeUser';

const ADSENSE_SCRIPT_ID = 'sa-google-adsense';
const ADSENSE_SRC =
  'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9840881106215536';

const AdScripts = () => {
  const { user, isLoading } = useAuth();
  const adFree = isAdFreeUser(user);

  useEffect(() => {
    if (isLoading) return;

    const existing = document.getElementById(ADSENSE_SCRIPT_ID);

    if (adFree) {
      if (existing) existing.remove();
      return;
    }

    if (existing) return;

    const script = document.createElement('script');
    script.id = ADSENSE_SCRIPT_ID;
    script.async = true;
    script.src = ADSENSE_SRC;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
  }, [adFree, isLoading]);

  return null;
};

export default AdScripts;
